import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { actions as mainActions } from "../../../actions/main";
import { Notification } from "../notification";

export const PaymentError = () => {
  const { paymentError } = useSelector(state => state.main);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const togglePaymentError = useCallback((isActive, errorMessage) => dispatch(mainActions.togglePaymentError(isActive, errorMessage)), [
    dispatch
  ]);

  // Callers may pass either an i18n key or a literal server string. nsSeparator
  // must be disabled so a message containing ":" is not parsed as a namespace,
  // and defaultValue makes a non-key string pass through untouched.
  const rawMessage = paymentError.errorMessage || "dashboard_common_error_generic_exclaim";
  const messageError = t(rawMessage, { nsSeparator: false, defaultValue: rawMessage });

  if (!paymentError.isActive) {
    return null;
  }

  return (
    <Notification error close={() => togglePaymentError(false, "")}>
      {messageError}
    </Notification>
  );
};
